import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, mapTo } from 'rxjs/operators';
import { AddressSearchParams, DeliveryAddress, DeliveryAddressSearchResult } from '../../model';
import { UserInputCheck } from '../../model/misc.model';

@Injectable({
  providedIn: 'root',
})
export class AddressConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  validatePostalCode(postalCode: string, userId: string, countryIsoCode?: string): Observable<UserInputCheck> {
    const queryParams = {
      postalCode: postalCode,
    };
    if (!!countryIsoCode) {
      queryParams['countryIsoCode'] = countryIsoCode;
    }
    const url = this.occEndpointsService.buildUrl('postalCodeCheck', { urlParams: { userId: userId }, queryParams });
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    return this.httpClient.get<UserInputCheck>(url, { headers }).pipe(
      mapTo({ valid: true, message: '' }),
      catchError((res) => {
        return of({ valid: false, message: res.error.errors[0]?.message });
      })
    );
  }

  validatePhoneNumber(userId: string, phoneNumber: string): Observable<UserInputCheck> {
    const url = this.occEndpointsService.buildUrl('phoneNumberCheck', {
      queryParams: {
        phone: phoneNumber,
      },
    });

    let headers = new HttpHeaders();

    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    return this.httpClient.get<UserInputCheck>(url, { headers }).pipe(
      mapTo({ valid: true, message: '' }),
      catchError((res) => {
        return of({ valid: false, message: res.error?.errors[0]?.message });
      })
    );
  }

  loadDeliveryAddresses(searchParams: AddressSearchParams, userId: string): Observable<DeliveryAddressSearchResult> {
    const url = this.occEndpointsService.buildUrl('customDeliveryAddresses', {
      urlParams: { userId: userId },
      queryParams: {
        fields: 'FULL',
        search: searchParams.text,
        page: searchParams.page ?? 0,
        count: searchParams.count ?? 10,
        sort: 'name1:asc',
      },
    });
    return this.httpClient.get<DeliveryAddressSearchResult>(url);
  }

  deleteDeliveryAddress(id: string, userId: string): Observable<any> {
    const url = this.occEndpointsService.buildUrl('customDeliveryAddress', { urlParams: { userId: userId, id: id } });
    return this.httpClient.delete(url);
  }

  saveDeliveryAddress(address: DeliveryAddress, userId: string): Observable<DeliveryAddress | any> {
    const url = this.occEndpointsService.buildUrl('customDeliveryAddresses', { urlParams: { userId: userId } });
    if (address?.id) {
      return this.httpClient.put(url, address);
    }
    return this.httpClient.post(url, address);
  }
}
